export default __webpack_public_path__ + "static/media/5osimce.a3430aab.webp";